<template>
    <div>
        <el-form :model="queryParams" ref="queryForm" :inline="true" style="overflow: hidden;">
            <el-row type="flex"
                style="display: inline;white-space:nowrap; font-size: calc(13vw * 100 / 1920); overflow-x: hidden;">
                <el-col :span="5">
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker clearable size="small" v-model="queryParams.startTime" type="date"
                            value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="startNoTime">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="结束时间" prop="endTime">
                        <el-date-picker clearable size="small" v-model="queryParams.endTime" type="date"
                            value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="endNoTime">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="flag">
                        <el-radio-group v-model="queryParams.type">
                            <el-radio :label="'修改'">修改</el-radio>
                            <el-radio :label="'新增'">新增</el-radio>
                            <el-radio :label="''">全部</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="创建人" prop="createMan">
                        <el-input clearable v-model.trim="queryParams.createMan" placeholder="请输入创建人"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="描述" prop="description">
                        <el-input clearable v-model.trim="queryParams.description" placeholder="请输入描述"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item>
                        <el-button style="width: 100%;" type="primary" @click="submit" plain>查询</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <main>
            <el-table :data="tableData" height="calc(100vh - 185px)" border :cell-style="rowStyle"
                style="width: 100%; font-size: calc(13vw * 100 / 1920);" :row-class-name="tableRowClassName">
                <el-table-column type="index" fixed width="50" label="序号" align="center">
                </el-table-column>
                <el-table-column fixed prop="createTime" label="日期" width="150vw" align="center">
                </el-table-column>
                <el-table-column fixed prop="createMan" label="创建人" width="100vw" align="center">
                </el-table-column>
                <el-table-column prop="type" label="状态" width="100vw" align="center">
                </el-table-column>
                <el-table-column prop="description" label="描述" class="description-column" align="center" width="auto">
                </el-table-column>
            </el-table>
        </main>
        <!-- <img style="width: 200px;height: 200px;" src="D:/test/张总png透明图.png" alt=""> -->
        <footer>
            <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10,30,50,70,90,100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </footer>
    </div>
</template>

<script>
export default {
    name:'sampleLog',
    data() {
        return {
            queryParams: {
                createMan: '',  //创建人
                description: '',  //描述
                startTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                type: '',//选择

            },
            tableData: [],
            currentPage: 1, // 当前页数
            pageSize: 13, // 每页显示的数据量
            total: 0, // 总数据量
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
        }
    },
    watch: {
        "queryParams.startTime": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "queryParams.endTime": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.type == '修改') {
                return 'warning-row';
            } else if (row.type == '新增') {
                return 'success-row';
            }
        },
        rowStyle() {
            return "text-align:center";
        },
        submit() {
            this.getData(1);
        },  // 页数发生改变时
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData(this.currentPage);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getData(this.currentPage)

        },
        getData(page) {
            this.currentPage = page;
            this.$api.getLogList( this.currentPage, this.pageSize, this.queryParams ).then(res =>{
                this.total = res.total;
                this.tableData = res.records;
            })
        },
    },
}
</script>

<style lang="css" scoped>
.custom-form-item .el-form-item__label {
    display: inline-block;
    vertical-align: middle;
}

.el-form-item {
    margin-bottom: 0;
}

::v-deep .el-table .el-table__cell {
    padding: 0;
}

::v-deep .el-table .warning-row {
    background: oldlace;
}

::v-deep .el-table .success-row {
    background: #f0f9eb;
}

::v-deep .el-pagination {
    padding: 0;
}

::v-deep .description-column  .cell {
    white-space: normal;
    word-wrap: break-word;
    /* background-color: aqua; */
}
</style>